import { useQuery, useQueryClient } from "@tanstack/react-query";

import { fetchCalls } from "../api/calls";
import { useMqttSubscription } from "./useMqtt";

export function useLiveCalls() {
  const q = useQuery({
    queryKey: ["calls", "live"],
    queryFn: () => fetchCalls(),
  });
  const qc = useQueryClient();

  // Invalidate on any state event — the wildcard `call/+/state` is fine at v1 scale.
  useMqttSubscription("call/+/state", () => {
    void qc.invalidateQueries({ queryKey: ["calls", "live"] });
  });

  return q;
}

export function useEngagementCalls(engagementId: string) {
  return useQuery({
    queryKey: ["calls", "engagement", engagementId],
    queryFn: () => fetchCalls({ engagement_id: engagementId }),
    enabled: Boolean(engagementId),
  });
}
